import classNames from 'classnames';
import { DragEvent, FC } from 'react';

import { IcMediaIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView } from '@gem/ui-kit';

import styles from './DropPanel.styles.m.css';

interface DropPanelProps {
  isDragging: boolean;
  onDrop?(event: DragEvent): void;
}
export const DropPanel: FC<DropPanelProps> = ({ isDragging, onDrop }) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(styles.container, {
        [styles.dragging]: isDragging,
      })}
      onDrop={onDrop}
    >
      <IconView
        Icon={IcMediaIcon}
        className={styles.icon}
      />
      {t('drop_to_send')}
    </div>
  );
};
